import { useEffect, useState } from 'react';
import cx from 'classnames';

const getInitialsFromName = (value: string) =>
    value
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(part => part[0]?.toUpperCase())
        .filter(Boolean)
        .slice(0, 2)
        .join('');

type Props = {
    onClick: () => void;
    isSelected: boolean;
    entity: string;
    name: string;
    src?: string;
    status: string;
    rounded?: boolean;
    isLight?: boolean;
    // 'sidebar' matches the sidebar rows (sand pill when selected)
    variant?: 'default' | 'sidebar';
    initials?: string;
    isDefault?: boolean;
};
export const SelectorOption = ({
    onClick,
    isSelected,
    entity,
    name,
    src,
    rounded = false,
    isLight = false,
    variant = 'default',
    initials,
    isDefault = false,
}: Props) => {
    const isSidebar = variant === 'sidebar';
    const [imageFailed, setImageFailed] = useState(false);
    const derivedInitials = initials?.trim() || getInitialsFromName(name);
    const showInitials = isDefault || !src || imageFailed;

    useEffect(() => {
        setImageFailed(false);
    }, [src]);

    return (
        <button
            onClick={onClick}
            className={cx(
                isSidebar
                    ? 'inline-flex gap-3 w-full items-center px-3 py-1.5 rounded-lg text-plum transition-colors duration-200'
                    : 'inline-flex space-x-[16px] w-full items-center px-[16px]  py-2 transition-all',
                isSidebar
                    ? isSelected
                        ? 'bg-starkWhite font-medium'
                        : 'hover:bg-starkWhite hover:bg-opacity-50'
                    : isSelected
                    ? isLight
                        ? 'text-[18.5px] text-lightPeach bg-woodyBrown  hover:bg-opacity-90'
                        : 'text-[18.5px] text-woodyBrown bg-lightPeach '
                    : isLight
                    ? 'hover:bg-woodyBrown text-woodyBrown hover:bg-opacity-5'
                    : 'hover:bg-white hover:text-white hover:bg-opacity-5',
            )}
        >
            {showInitials ? (
                <div
                    className={cx(
                        'shadow-md flex items-center justify-center font-semibold uppercase shrink-0',
                        isSidebar ? 'w-10 h-10 text-sm' : 'w-14 h-14 text-lg',
                        rounded ? 'rounded-full' : 'rounded-[8px]',
                        isSidebar
                            ? 'bg-plum text-lightPeach'
                            : isLight
                            ? 'bg-woodyBrown text-lightPeach'
                            : 'bg-lightPeach text-woodyBrown',
                    )}
                    aria-hidden="true"
                >
                    {derivedInitials || ''}
                </div>
            ) : (
                <img
                    className={cx(
                        'shadow-md object-cover shrink-0',
                        isSidebar ? 'w-10 h-10' : 'w-14 h-14',
                        rounded ? 'rounded-full' : 'rounded-[8px]',
                    )}
                    src={src}
                    alt="avatar consumer"
                    onError={() => setImageFailed(true)}
                />
            )}
            <div className="text-left truncate">
                <p className="text-[14px] leading-none ">{name}</p>
                <p className="text-[10px] font-extralight">{entity}</p>
            </div>
        </button>
    );
};
